import { render, staticRenderFns } from "./BrazeEventTrigger.vue?vue&type=template&id=04e87da8&scoped=true&"
import script from "./BrazeEventTrigger.vue?vue&type=script&lang=js&"
export * from "./BrazeEventTrigger.vue?vue&type=script&lang=js&"
import style0 from "./BrazeEventTrigger.vue?vue&type=style&index=0&id=04e87da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e87da8",
  null
  
)

export default component.exports